import React from "react";
import { Link } from "react-router-dom";

import TopBar from "../../../../components/TopBar";
import TopBarProspectiveStudent from "../../../../components/ComponentsProspeciveStudentPage/TopBarProspectiveStudent";
// import QuestionPM from "../../../../components/ComponentsUndergraduatePage/ICTE/QuestionPM";
import Footer from "../../../../components/Footer";
import Container from "../../../../components/Container";

import img from "../../../../assets/images/EducationalPrograms/EducationalProgramsIEE/sidorov.PNG";
import doc from "../../../../assets/documents/uch-plan/magistratura/technichinformobespech.pdf";

import img1 from "../../../../assets/images/New/MagPRCETeacher/info-block/info_block_img1.png";
import img2 from "../../../../assets/images/New/MagPRCETeacher/info-block/info_block_img2.png";
import img3 from "../../../../assets/images/New/MagPRCETeacher/info-block/info_block_img3.png";

import img_company1 from "../../../../assets/images/New/MagTIOPTeacher/companies/img_company1.png";
import img_company2 from "../../../../assets/images/New/MagTIOPTeacher/companies/img_company2.png";
import img_company3 from "../../../../assets/images/New/MagTIOPTeacher/companies/img_company3.png";
import "./TIOPTeacherPage.css";

export default function TIOPTeacherPage() {

    return (
        <React.Fragment>
            <TopBar />
            <TopBarProspectiveStudent />
            <Container>
                <div className="educational-program magistracy teacher tiop">
                    <span className="teacher__title">Техническое и информационное обеспечение проектирования и функционирования электроэнергетического хозяйства потребителей
                    </span>
                    <div className="teacher__main-block">
                        <div className="teacher__main-block-img sidorov">
                            <img src={img} alt="" />
                        </div>
                        <div className="teacher__main-block-text">
                            <span className="teacher__text">Руководитель образовательной программы</span>
                            <span className="teacher__title">Сидоров Александр Евгеньевич</span>
                            <span className="teacher__text">к.т.н., доцент кафедры <br /> 
                            «Электрооборудование и электрохозяйтсво <br />
                            предприятий, организаций и учреждений» (ЭХП)</span>
                            <div className="teacher__main-block-text-row">
                                <span className="teacher__text">e-mail:</span>
                                <span className="teacher__text">asidorini@rambler.ru</span>
                            </div>
                            <div className="teacher__main-block-text-row">
                                <span className="teacher__text">тел.:</span>
                                <span className="teacher__text"> 8 (843) 519-43-45</span>
                            </div>
                            <span className="teacher__text">420066, г. Казань, ул. Красносельская, 51, каб. Д-727
                            </span>
                            <div className="teacher__main-block-text-row">
                                <Link to="//priem.kgeu.ru/user/sign-in/login" className="teacher__button">Подать документы</Link>
                                {/* {/* <Link to={doc} className="teacher__button" target="_blank">Узнать подробнее</Link> */}
                                <a href={doc} target="_blank" className="teacher__button">Учебный план </a>
                                
                            </div>
                        </div>
                        <div className="magpage_about_frame" >
                            <span className="magpage_about_programm_title">О программе</span>
                            <span className="magpage_about_programm_text">
                                Программа направлена на подготовку высококвалифицированных специалистов,
                                деятельность которых связана с проектированием, эксплуатацией 
                                электроэнергетических систем, а также с  организацией и управлением 
                                функционирования электроэнергетического хозяйства потребителей.
                            </span>
                        </div>
                    </div>
                    <div className="teacher__info-block">
                        <div className="info-block-frame" >
                            <span className="info_block-title">Учебные дисциплины</span>
                            <div className="info_block-text_area">
                                <span className="info_block-title2">Базовые</span>
                                <div className="info_block-text-row">
                                    <span className="number">01</span>
                                    <span className="text-line">Методы и организация научных экспериментов при проектировании АСУП</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">02</span>
                                    <span className="text-line">Проектирование автоматизированных систем управления в электроэнергетике</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">03</span>
                                    <span className="text-line">Интеллектуальная электроэнергетическая система с активно-адаптивной сетью</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">04</span>
                                    <span className="text-line">Надежность и устойчивость электроэнергетических систем</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">05</span>
                                    <span className="text-line">Методология и инновационные технологии проектирования в электроэнергетике</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">06</span>
                                    <span className="text-line">Инновации в энергетике</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">07</span>
                                    <span className="text-line">Управление проектами в энергетике.</span>
                                </div>
                                
                                
                                <span className="info_block-title2">Вариативные</span>
                                <div className="info_block-text-row">
                                    <span className="number">01</span>
                                    <span className="text-line">Организация управления персоналом при проектировании электроэнергетических сетей</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">02</span>
                                    <span className="text-line">Проектирование электроэнергетических сетей и режимов их работы</span>
                                </div>
                            </div>
                        </div>  
                        <div className="info-block-stack">
                            <div className="info-block-frame2">
                            <span className="info_block-title">Кем я смогу работать?</span>

                            <div className="info_block-text_area">
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img1}/></div>
                                    <span className="text-line">BIM-проектировщиком</span>
                                </div>
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img2}/></div>
                                    <span className="text-line">Руководиелем проекта</span>
                                </div>
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img3}/></div>
                                    <span className="text-line">Инженером АСУТП</span>
                                </div>
                            </div>
                            </div>

                            <div className="info-block-frame3">
                                <span className="info_block-title">Трудоустройство</span>
                                <div className="info_block-text-row">
                                    <img src={img_company1}/>
                                    <img src={img_company2}/>
                                </div>
                                <div className="info_block-text-row">
                                    <img src={img_company3}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <QuestionPM /> */}
                </div>
            </Container>
            <Footer />
        </React.Fragment>

    );
}